<template>
    <n-dialog-provider>
        <router-view v-slot="{Component}" v-if="!state.loading">
            <keep-alive>
                <component :is="Component" v-if="$route.meta.keepAlive" :key="$route.name"></component>
            </keep-alive>
            <component :is="Component" v-if="!$route.meta.keepAlive" :key="$route.name"></component>
        </router-view>
    </n-dialog-provider>
</template>
<script lang="ts">
import Cookies from 'js-cookie'
import {defineComponent, onMounted, onBeforeMount, reactive} from 'vue'
import {useGetAlbumDetail, useAlbumAttr, getRedirectUrl, getH5Url, getOpenId} from '@/views/api'
import {getUUID, getUrlParams, LoadWechatConfig, getIsWxClient, computedResources, weChatLogin} from './utils'
import {useAlbumStore} from '@/store/album'
import {NDialogProvider} from 'naive-ui'
import {useThemeStore} from './store/theme'
import {useRoute, useRouter} from 'vue-router'
import config from '@/config'

export default defineComponent({
    components: {
        NDialogProvider
    },
    setup() {
        const state = reactive({
            loading: true
        })
        // 判断是否为特殊版本
        let specialVersion = false
        const albumStore = useAlbumStore()
        const themeStroe = useThemeStore()
        const router = useRouter()
        const route = useRoute()
        // 特殊版本 用于检测问题
        let body = document.body
        if (specialVersion) {
            let dom = document.createElement('div')
            dom.innerText = '进入APP.vue的onMounted前'
            body.appendChild(dom)
        }
        onMounted(async () => {
            if (config.EVN.env == 'prod/album') {
                const version = location.pathname.split('/')[2]
                try {
                    const res = await getH5Url({h5Type: 'ALBUM_SHARE', version})
                    sessionStorage.setItem('serverUrl', res.serverUrl)
                    if (res.newVersion !== version) {
                        window.location.replace(`${location.origin}/albumshare/${res.newVersion}/index.html${location.search}${location.hash}`)
                    }
                } catch (error) {
                    console.log('error', error)
                }
            }

            if (specialVersion) {
                let dom = document.createElement('div')
                dom.innerText = '进入APP.vue的onMounted中'
                body.appendChild(dom)
            }

            if (Cookies.get('store')) {
                albumStore.$patch(Object.assign({}, albumStore.$state, JSON.parse(Cookies.get('store'))))
            }
            let uuid = Cookies.get('uuid')
            if (!uuid) {
                Cookies.set('uuid', getUUID())
            }
            let params: any = getUrlParams()
            if (params && params.gatherId) {
                albumStore.gatherId = params.gatherId
                state.loading = false
                router.replace('/gather')
            }
            if (params && params.userId) {
                state.loading = false
            }
            if (params && params.albumId) {
                if (specialVersion) {
                    let dom = document.createElement('div')
                    dom.innerText = `获取到地址栏的参数相册id${params.albumId}`
                    body.appendChild(dom)
                }
                albumStore.albumId = params.albumId
                if (params.showWatermark === false || params.showWatermark === 'false') {
                    albumStore.showWatermark = false
                }
                if (params.debug === true || params.debug === 'true') {
                    albumStore.debug = true
                }
                if (params.puzzle === true || params.puzzle === 'true') {
                    albumStore.puzzle = true
                }
                if (params.formMini === true || params.formMini === 'true') {
                    albumStore.formMini = true
                }
                if (params.sharePoster === true || params.sharePoster === 'true') {
                    albumStore.sharePoster = true
                }
                if (params.code && (localStorage.getItem('openId') === 'undefined' || !localStorage.getItem('openId'))) {
                    let res = await getOpenId({code: params.code, forceLogin: false})
                    albumStore.openId = res.openId
                    localStorage.setItem('openId', res.openId)
                }
                console.log('当前请求地址', sessionStorage.getItem('serverUrl'))
                useGetAlbumDetail({albumId: params.albumId})
                    .then(async res => {
                        state.loading = false
                        if (res) {
                            if (res.id) {
                                document.title = res.sharePageTitle || res.title
                                albumStore.cndUrl = res.cndUrl
                                // albumStore.processUrl = res.processUrl
                                albumStore.userHomeId = res.userHomeId
                                albumStore.loadingUrl = res.loadingUrl
                                albumStore.loadingSize = res.loadingSize
                                albumStore.payPhotoType = res.payPhotoType
                                albumStore.canDownload = res.canDownload
                                Cookies.set('albumToken', res.albumToken)
                                // 如果没有水印 --- 是否强制加水印
                                if (params.showWatermark === false || params.showWatermark === 'false') {
                                    albumStore.showWatermark = res.mandatoryWatermark
                                } else {
                                    albumStore.showWatermark = !res.noMandatoryWatermark
                                }
                                if (res) {
                                    console.log('skinType：', res.skinType)
                                    getThemeConfig(res.skinType)
                                }
                                if (specialVersion) {
                                    let dom = document.createElement('div')
                                    dom.innerText = `获取相册详情成功`
                                    body.appendChild(dom)
                                }

                                if (getIsWxClient()) {
                                    initWechatConfig(res.shareCardTitle || res.title, res.sharePhotoUrl, res.shareDesc)
                                }
                                // localStorage.setItem('openId', 'oUReL5j_ckSuqWJR_HM_xQ5Y-p28')
                                // albumStore.openId = 'oUReL5j_ckSuqWJR_HM_xQ5Y-p28'
                                // 如果开启付费照片功能 -- 必须在微信环境执行登录

                                let isVote = false
                                try {
                                    const res = await useAlbumAttr({albumId:params.albumId, attrType: 'INTERACTIVE'})
                                    // console.log('获取互动设置：', res)
                                    isVote = res.attrInteractive.vote
                                } catch (error) {
                                    console.log('app.vue 获取互动设置失败：', error)
                                }
                                
                                if ((res.payPhotoType == 'PAY_PHOTO' || isVote) && route.path !== '/downLoadPackage') {
                                    if (getIsWxClient()) {
                                        if (localStorage.getItem('openId') && localStorage.getItem('openId') !== 'undefined') {
                                            albumStore.openId = localStorage.getItem('openId')
                                        } else {
                                            weChatLogin('wx022a8a4c745cb156', location.href)
                                        }
                                    }
                                }

                                // console.log('当前请求res =======================>', res)
                                albumStore.forceModeDesc = res.forceModeDesc
                                albumStore.forceMode = res.forceMode
                                if (res.privacy !== "VERIFIED" && res.forceMode !== 'NONE' && route.path === '/') {
                                    if (res.forceMode === 'FACE') {
                                        router.push({ path: '/searchFace', query: { type: 'findPerson' } })
                                    } else if (res.forceMode === 'NUMBER') {
                                        router.push({ path: '/numberIdentify' })
                                    } else if (res.forceMode === 'FILE_NAME') {
                                        router.push('/fileNameSearch')
                                    }
                                }

                            } else if (res.code === 7) {
                                router.replace('/dissolveAlbum')
                            }
                        }
                    })
                    .catch(error => {
                        state.loading = false
                        console.log(error)
                    })
            }
        })
        const initWechatConfig = async (title: string, sharePhotoUrl: string, shareDesc: string) => {
            if (specialVersion) {
                let dom = document.createElement('div')
                dom.innerText = `判断为微信的环境，初始化微信分享配置`
                body.appendChild(dom)
            }

            let url = window.location.href.split('#')[0].toString()
            // console.log(url, title, sharePhotoUrl, shareDesc)
            LoadWechatConfig(url, title, sharePhotoUrl, shareDesc)
        }
        const getThemeConfig = (skinType: string) => {
            themeStroe.theme = {skinType}
            const head = document.head
            let lessUrl = computedResources(`SKIN.less`)
            if (lessUrl) {
                let element = document.createElement('link')
                element.setAttribute('rel', 'stylesheet')
                element.setAttribute('type', 'text/less')
                element.setAttribute('href', lessUrl + '?t=' + new Date().getTime())

                const script = document.createElement('script')
                script.type = 'text/JavaScript'
                script.src = 'https://res.kapaisy.com/config/2.0.0/less.min.js'
                head.appendChild(element)
                head.appendChild(script)
            }

            if (specialVersion) {
                let dom = document.createElement('div')
                dom.innerText = `动态加载皮肤`
                body.appendChild(dom)
            }
        }
        return {
            state
        }
    }
})
</script>
